// extracted by mini-css-extract-plugin
module.exports = {"gradientBlock":"gradient-module__gradientBlock___2svME","animateGradient":"gradient-module__animateGradient___2nSdy"};